import React, { useEffect, useState } from 'react';
import { CardGroup, Container, ContentCard, DropdownSelector, Paper } from 'library';
import { take } from 'lodash';
import { browserTrack } from 'utils/segment';
import { filterCategoriesByName, filterPostsByCategory } from 'utils/wpUtilities';

import { mapBlogToComponent } from '../../blocks/CardGroupBlock/cardGroupBlockUtils';
import CategoryNav from '../../common/CategoryNav/CategoryNav';
import LoadMore from '../../common/Pagination/LoadMore';
import usePagination from '../../common/Pagination/UsePagination';
import Layout from '../../layout';

import './BlogCategoryFeed.scss';

const BlogCategoryFeed = ({ data }) => {
  const { page, post, category } = data;
  const [value, setValue] = useState();
  const categories = category.edges;

  useEffect(() => {
    browserTrack('Blog Category Viewed', {
      blog_post_category: page.slug,
    });
  }, [page.slug]);

  const filterBlogPostsByCategory = (slug, posts) => {
    if (slug === 'financial-goals' && value) {
      return filterPostsByCategory(value, posts);
    } else {
      return filterPostsByCategory(slug, posts);
    }
  };

  const unsortedCategorisedPosts = filterBlogPostsByCategory(page.slug, post.nodes);
  const categorisedPosts = unsortedCategorisedPosts.sort((a, b) => new Date(b.date) - new Date(a.date));
  const { hasMoreToLoad, countVisible, handleLoadMore } = usePagination({
    total: categorisedPosts?.length,
    initialPageCount: 12,
    incrementLimit: 12,
  });

  return (
    <div className="BlogCategoryFeed">
      <Layout>
        <Paper theme="medium" pad={{ bottom: 5 }}>
          <CategoryNav activeSlug={page.slug} categories={filterCategoriesByName('blog', categories)} />

          {page.slug === 'financial-goals' && (
            <Container justify="center" row>
              <Container grid="4">
                <DropdownSelector
                  label="I want to tap into my home equity to:"
                  name="selector"
                  value={value}
                  placeholder="Choose an option"
                  options={filterCategoriesByName('financial-goals', categories)}
                  onChange={(val) => {
                    browserTrack('Content Filtered', {
                      content_type: window.location.pathname.split('/')[1],
                      text: val,
                      style: 'category-nav-financial-goals',
                    });
                    setValue(val);
                  }}
                />
              </Container>
            </Container>
          )}

          <CardGroup cardSize={ContentCard.size} title={page.title}>
            {take(categorisedPosts, countVisible).map((post, index) => {
              const displayCategory = post.categories.nodes.find((cat) => {
                if (page.slug === 'financial-goals') {
                  return value ? cat.slug === value : cat.slug !== 'financial-goals' && cat.slug !== 'blog';
                }
                return cat.slug === page.slug;
              });

              return <ContentCard {...mapBlogToComponent(post)} category={displayCategory?.name} key={index} />;
            })}
            {categorisedPosts.length === 4 || categorisedPosts.length === 2 ? <div></div> : []}
          </CardGroup>
          {hasMoreToLoad && <LoadMore onClick={handleLoadMore} />}
        </Paper>
      </Layout>
    </div>
  );
};

export default BlogCategoryFeed;
